/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IContractsAccountPageViewProps } from './contracts-account-page';
import { Module } from '@msdyn365-commerce-modules/utilities';

export default (props: IContractsAccountPageViewProps) => {
    const { contractsHeading, contractsWrapper, contractsTable, contractsLinks } = props;
    return (
        <Module {...contractsWrapper}>
            {contractsHeading}
            {contractsTable}
            {contractsLinks}
        </Module>
    );
};
